import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { PropertyModel } from 'src/app/models/property.model';
import { SearchModel } from 'src/app/models/search.model';
import { EventService } from 'src/app/services/event.service';
import { UtilsPropertiesService } from 'src/app/services/utils-properties.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-desktop-properties',
  templateUrl: './desktop-properties.component.html',
  styleUrls: ['./desktop-properties.component.css'],
})
export class DesktopPropertiesComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @Input() highlightsProperties: any[] = [];
  @Input() properties!: PropertyModel[];
  @Input() searchData!: any;
  @Input() total!: number;
  @Input() filters: any;
  @Input() checkedCharacteristics: any[] = [];
  @Input() isNearby: boolean = false;
  stateView: BehaviorSubject<boolean> = new BehaviorSubject(true);
  sortingOptions = [
    // {
    //   value: { by: 'createdAt', dir: 'asc' },
    //   name: 't-default-order',
    // },
    {
      value: { by: 'createdAt', dir: 'desc' },
      name: 't-recent-added',
    },
    {
      value: { by: 'updatedAt', dir: 'desc' },
      name: 't-recent-updated',
    },
    {
      value: { by: 'price', dir: 'asc' },
      name: 't-price-low-to',
    },
    {
      value: { by: 'price', dir: 'desc' },
      name: 't-price-high-to',
    },
  ];
  sortingValue: any = { by: 'createdAt', dir: 'desc' };
  page: number = 1;
  pageSize: number = 8;
  areaValue = 0;
  priceValue = 0;
  areaMaxValue: number = 0;
  priceMaxValue: number = 0;
  searchResult: any[] = [];
  searchForm!: SearchModel;
  county: any[] = [];
  parish: any[] = [];
  selectedDistrict: any;
  selectedCounty: any;
  selectedParish: any;
  initFilters: boolean = false;
  otherChars: boolean = false;
  activeFeatured: number = 0;
  featuredInterval: any;
  priceChange: boolean = false;
  areaChange: boolean = false;

  constructor(
    private eventService: EventService,
    private translateService: TranslateService,
    private router: Router,
    public utilsPropertiesService: UtilsPropertiesService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      if (params.keys.length > 0) {
        params.keys.map((key) => {
          if (key == 'page') {
            this.page = Number(params.get(key));
          }
        });
      }
    });
    this.initSearchForm();
  }

  ngAfterViewInit(): void {
    const interval = setInterval(() => {
      if (this.highlightsProperties && this.highlightsProperties.length > 0) {
        this.autoChangeDots();
        clearInterval(interval);
      }
    }, 200);
  }

  autoChangeDots() {
    let el = document.getElementById('slick-highlights-desktop');
    if (!this.featuredInterval) {
      this.featuredInterval = setInterval(() => {
        if (el) {
          if (this.activeFeatured + 1 < this.highlightsProperties.length) {
            this.activeFeatured++;
            const width: any = document.getElementById(
              'featured-property-0'
            )?.offsetWidth;
            const calc =
              this.activeFeatured > 0
                ? this.activeFeatured * width
                : this.activeFeatured;
            el.style.transform = `translate3d(-${calc}px,0,0)`;
          } else {
            el.style.transform = `translate3d(0px,0,0)`;
            this.activeFeatured = 0;
          }
        } else {
          el = document.getElementById('slick-highlights-desktop');
        }
      }, 5000);
    }
  }

  pauseInterval() {
    if (this.featuredInterval) {
      clearInterval(this.featuredInterval);
      this.featuredInterval = null;
    }
    if (!this.featuredInterval) {
      setTimeout(() => {
        this.autoChangeDots();
      }, 5000);
    }
  }

  compareFn(item1: any, item2: any): boolean {
    return item1 && item2
      ? item1.value.by === item2.by && item1.value.dir === item2.dir
      : false;
  }

  changeFeatured(direction: 'next' | 'prev', el: HTMLDivElement) {
    this.pauseInterval();
    if (direction === 'next') {
      if (this.activeFeatured + 1 < this.highlightsProperties.length) {
        this.activeFeatured++;
        const width: any = document.getElementById(
          'featured-property-0'
        )?.offsetWidth;
        const calc =
          this.activeFeatured > 0
            ? this.activeFeatured * width
            : this.activeFeatured;
        el.style.transform = `translate3d(-${calc}px,0,0)`;
      } else {
        el.style.transform = `translate3d(0px,0,0)`;
        this.activeFeatured = 0;
      }
    } else {
      if (this.activeFeatured != 0) {
        this.activeFeatured--;
        const width: any = document.getElementById(
          'featured-property-0'
        )?.offsetWidth;
        const calc =
          this.activeFeatured > 0
            ? this.activeFeatured * width
            : this.activeFeatured;
        el.style.transform = `translate3d(-${calc}px,0,0)`;
      }
    }
  }

  districtChange() {
    this.selectedCounty = null;
    this.selectedParish = null;
    this.county = [];
    this.parish = [];
    if (this.selectedDistrict && this.selectedDistrict != '') {
      let selected = this.selectedDistrict.split('-');
      const country = selected[0];
      const district = selected[1];
      const region = selected[2];
      for (const [key, value] of Object.entries<any>(
        this.searchData?.locations
      )) {
        if (
          value.countryId == country &&
          value.id == district &&
          value.regionId == region
        ) {
          value.counties.forEach((county: any) => {
            this.county.push(county);
          });
        }
      }
    } else {
      this.clearFilter('location');
    }
  }

  countyChange() {
    this.selectedParish = null;
    this.parish = [];
    this.county.forEach((c) => {
      if (c.id == this.selectedCounty) {
        c.parishs.forEach((parish: any) => {
          this.parish.push(parish);
        });
      }
    });
  }

  priceFormat(propertyPrice: any, symbol: any = '€') {
    const spaces = (price: any) =>
      String(price).replace(/(?!^)(?=(?:\d{3})+$)/g, ' ');
    return symbol + ' ' + spaces(propertyPrice);
  }

  initSearchForm() {
    const interval2 = setInterval(() => {
      if (this.searchData) {
        this.areaMaxValue = this.filters?.areaMax
          ? this.filters?.areaMax
          : this.searchData.areaMax;
        this.areaValue = this.filters?.areaMin ? this.filters?.areaMin : 0;
        this.priceMaxValue = this.filters?.priceMax
          ? this.filters?.priceMax
          : this.searchData.priceMax;
        this.priceValue = this.filters?.priceMin ? this.filters?.priceMin : 0;
        if (this.filters.location) {
          this.setLocationsByFilter();
        }
        this.initFilters = true;
        clearInterval(interval2);
      }
    }, 100);
    this.searchForm = {
      businessType: this.filters.businessType
        ? this.filters.businessType
        : null,
      propertyType: this.filters.propertyType
        ? this.filters.propertyType
        : null,
      propertyCondition: this.filters.propertyCondition
        ? this.filters.propertyCondition
        : null,
      bathrooms: this.filters.bathrooms || this.filters.bathrooms == 0 ? this.filters.bathrooms : null,
      bedrooms: this.filters.bedrooms || this.filters.bedrooms == 0 ? this.filters.bedrooms : null,
      characteristics: [],
      reference: this.filters.reference ? this.filters.reference : null,
    };
  }

  inputChange(type: 'area' | 'price') {
    if (type === 'area') {
      this.areaChange = true;
      this.areaValue > this.areaMaxValue
        ? (this.areaMaxValue = this.areaValue)
        : null;
    } else {
      this.priceChange = true;
      this.priceValue > this.priceMaxValue
        ? (this.priceMaxValue = this.priceValue)
        : null;
    }
  }

  clearFilter(filter: any) {
    this.eventService.broadcast('clear-filter', filter);
  }

  setLocationsByFilter() {
    let location = JSON.parse(this.filters.location);
    if (location.parish) {
      this.selectedDistrict = location.country + '-' + location.district + '-' + location.region;
      this.districtChange();
      this.selectedCounty = location.county;
      this.countyChange();
      this.selectedParish = location.parish;
    } else if (location.county) {
      this.selectedDistrict = location.country + '-' + location.district + '-' + location.region;
      this.districtChange();
      this.selectedCounty = location.county;
      this.countyChange();
    } else if (location.district) {
      this.selectedDistrict = location.country + '-' + location.district + '-' + location.region;
      this.districtChange();
    }
  }

  changeLayout(type: boolean) {
    this.stateView.next(type);
  }

  orderChange() {
    this.eventService.broadcast('order-properties', this.sortingValue);
  }

  prepareSearchData() {
    if (this.selectedDistrict) {
      let selected = this.selectedDistrict.split('-');
      if (this.selectedCounty) {
        if (this.selectedParish) {
          for (const [key, value] of Object.entries<any>(
            this.searchData.locations
          )) {
            if (
              value.countryId == selected[0] &&
              value.id == selected[1] &&
              value.regionId == selected[2]
            ) {
              for (const [key1, value1] of Object.entries<any>(
                value.counties
              )) {
                if (value1.id == this.selectedCounty) {
                  for (const [key2, value2] of Object.entries<any>(
                    value1.parishs
                  )) {
                    if (value2.id == this.selectedParish) {
                      this.searchForm.location = {
                        country: value.countryId,
                        region: value.regionId,
                        district: value.id,
                        county: value1.id,
                        parish: value2.id,
                      };
                    }
                  }
                }
              }
            }
          }
        } else {
          for (const [key, value] of Object.entries<any>(
            this.searchData.locations
          )) {
            if (
              value.countryId == selected[0] &&
              value.id == selected[1] &&
              value.regionId == selected[2]
            ) {
              for (const [key1, value1] of Object.entries<any>(
                value.counties
              )) {
                if (value1.id == this.selectedCounty) {
                  this.searchForm.location = {
                    country: value.countryId,
                    region: value.regionId,
                    district: value.id,
                    county: value1.id
                  };
                }
              }
            }
          }
        }
      } else {
        for (const [key, value] of Object.entries<any>(
          this.searchData.locations
        )) {
          if (
            value.countryId == selected[0] &&
            value.id == selected[1] &&
            value.regionId == selected[2]
          ) {
            this.searchForm.location = {
              country: value.countryId,
              region: value.regionId,
              district: value.id,
            };
          }
        }
      }
    }
    document
      .querySelectorAll('.beds-items button')
      .forEach((el) =>
        el.classList.contains('active')
          ? (this.searchForm.bedrooms = el.getAttribute('value'))
          : null
      );
    document
      .querySelectorAll('.bath-items button')
      .forEach((el) =>
        el.classList.contains('active')
          ? (this.searchForm.bathrooms = el.getAttribute('value'))
          : null
      );
    this.searchData.characteristics.forEach((char: any) => {
      const el: any = document.getElementById(`check-char-${char.id}`);
      el?.checked ? this.searchForm.characteristics?.push(char.id) : null;
    });
  }

  updateChars(id: any) {
    const index = this.checkedCharacteristics.indexOf(id);
    if (index > -1) {
      this.checkedCharacteristics.splice(index);
    }
  }

  filterSearch() {
    this.searchForm.characteristics = [];
    this.searchForm.location = null;
    this.prepareSearchData();
    const params = {
      bedrooms:
        this.searchForm.bedrooms != '' ? this.searchForm.bedrooms : null,
      bathrooms:
        this.searchForm.bathrooms != '' ? this.searchForm.bathrooms : null,
      businessType: this.searchForm.businessType,
      propertyType: this.searchForm.propertyType,
      propertyCondition: this.searchForm.propertyCondition,
      priceMin: this.priceChange ? this.priceValue : null,
      priceMax: this.priceChange ? this.priceMaxValue : null,
      areaMin: this.areaChange ? this.areaValue : null,
      areaMax: this.areaChange ? this.areaMaxValue : null,
      characteristics:
        this.searchForm?.characteristics?.length > 0
          ? JSON.stringify(this.searchForm.characteristics)
          : null,
      location: this.searchForm?.location
        ? JSON.stringify(this.searchForm.location)
        : null,
      reference: this.searchForm.reference ? this.searchForm.reference : null,
    };
    this.router.navigate(['/properties'], { queryParams: params });
  }

  refreshProperties() {
    this.router.navigate(['/properties'], { queryParams: { page: this.page } });
    // this.eventService.broadcast('refresh-properties', (this.page - 1) * this.pageSize);
    window.scrollTo({ top: 0 });
  }

  clearFilters() {
    this.areaMaxValue = this.searchData.areaMax;
    this.areaValue = 0;
    this.priceMaxValue = this.searchData.priceMax;
    this.priceValue = 0;
    this.searchForm.businessType = null;
    this.searchForm.propertyCondition = null;
    this.searchForm.propertyType = null;
    this.searchForm.reference = null;
  }

  ngOnDestroy(): void {
    if (this.featuredInterval) {
      clearInterval(this.featuredInterval);
    }
  }
}
